<template>
	<table class="list_tbl" v-columns-resizable>
		<thead>
			<tr>
				<th style="width: 1%">
					<input type="checkbox" v-model="selectedAll" @click="selectAll" />
				</th>
				<template v-for="(v, i) in showColumns">
					<th v-if="v[i_show]" :key="i" :style="{ width: v[i_width] }">
						<span class="pointer" @click="sort(v[i_key])">{{ v[i_name] }}</span>
						<span v-if="sort_key === v[i_key]">{{ sortSign }}</span>
					</th>
				</template>
			</tr>
		</thead>
		<tbody>
			<tr v-for="partner in partners" v-bind:key="partner.code">
				<td class="al_center">
					<input type="checkbox" v-model="partner.selected" />
				</td>
				<template v-for="(v, index) in showColumns">
					<td v-if="v[i_show]" :class="v[i_class]" :key="partner.code + index">
						<router-link v-if="v[i_key] === 'code'" tag="a" :to="{ name: 'partnerDetail', query: { code: partner[v[i_key]] }, params: { mode: 'detail' } }">{{ partner[v[i_key]] }}</router-link>

						<span v-else-if="v[i_key] === 'memo'" @click="memo(partner)" :class="partner.memo ? 'red_bold' : ''">Memo</span>

						<span v-else-if="v[i_key] === 'blocked' && partner.blocked" :title="partner.block_reason" class="red_bold">&#10004;</span>

						<template v-else-if="currencyList.includes(v[i_key])">
							<template v-if="!['ytd', 'last_invoice_amount'].includes(v[i_key])">
								<span :style="partner[v[i_key]] > 0 ? 'color:red' : partner[v[i_key]] < 0 ? 'color:blue' : 'color:black'">
									<span v-if="['balance', 'post_check_amount'].includes(v[i_key])" class="pointer" @click="$emit('arHistory', partner.code, partner.name)">
										{{ partner[v[i_key]] | toCurrency }}
									</span>
									<span v-else>
										{{ partner[v[i_key]] | toCurrency }}
									</span>
								</span>
							</template>
							<template v-else>
								<span>{{ partner[v[i_key]] | toCurrency }}</span>
							</template>
						</template>
						<span v-else-if="partner[v[i_key]]" :title="partner[v[i_key]]">{{ partner[v[i_key]] }}</span>
					</td>
				</template>
			</tr>
		</tbody>
	</table>
</template>
<script>
import { getColumns } from '@/api/partner/partnerTable';

export default {
	name: 'partnerTable',
	props: {
		company_id: {},
		partners: {},
		sort_direction: {
			type: String,
		},
		sort_key: {
			type: String,
		},
	},
	data() {
		return {
			selectedAll: false,
			i_key: 0,
			i_name: 1,
			i_show: 2,
			i_width: 3,
			i_class: 4,
			i_order: 5,
			currencyList: ['ytd', 'balance', 'post_check_amount', 'store_credit_amount', 'last_invoice_amount'],
		};
	},
	computed: {
		showColumns() {
			return getColumns(this.routerName, this.company_id);
		},
		routerName() {
			return this.$router.history.current.name;
		},
		sortSign() {
			return this.sort_direction === 'ASC' ? '▲' : '▼';
		},
	},
	methods: {
		sort(key) {
			this.$emit('sort', key);
		},
		selectAll() {
			this.partners.forEach(partner => {
				partner.selected = !this.selectedAll;
			});
		},
		memo(partner) {
			this.$emit('memo', partner);
		},
	},
};
</script>
